import {
  FETCH_STUDENT_APPROVED_COURSES_REQUEST,
  FETCH_STUDENT_APPROVED_COURSES_SUCCESS,
  FETCH_STUDENT_APPROVED_COURSES_FAILURE,
} from "../Actions/types";

const initialState = {
  loading: false,
  approvedCourses: [],
  error: null,
};

export const studentApprovedCoursesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STUDENT_APPROVED_COURSES_REQUEST:
      return { ...state, loading: true };

    case FETCH_STUDENT_APPROVED_COURSES_SUCCESS:
      return { loading: false, approvedCourses: action.payload, error: null };

    case FETCH_STUDENT_APPROVED_COURSES_FAILURE:
      return { loading: false, approvedCourses: [], error: action.payload };

    default:
      return state;
  }
};
